import { render, staticRenderFns } from "./MenuLayout.vue?vue&type=template&id=f1da4462&scoped=true&lang=pug&"
import script from "./MenuLayout.vue?vue&type=script&lang=ts&"
export * from "./MenuLayout.vue?vue&type=script&lang=ts&"
import style0 from "./MenuLayout.vue?vue&type=style&index=0&id=f1da4462&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1da4462",
  null
  
)

/* custom blocks */
import block0 from "./MenuLayout.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports